import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import ErrorIcon from '@mui/icons-material/Error';
import TotalAmountTable from './TotalAmountTable';

const DataText = styled(Typography)({
  '&&': {
    maxWidth: '50ch',
    marginTop: 40,
    marginBottom: 40,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

DataText.defaultProps = {
  variant: 'body1',
  align: 'center',
};

const DistributionsDataDisplay = ({
  isError,
  showUnPaidDistributions,
  unPaidDistributionsExist,
  paidDistributionsExist,
  displayedData,
  unPaidDistributions,
  showOtherDistributions,
}) => {
  if (isError) {
    return (
      <DataText>
        <ErrorIcon color="error" sx={{ mr: 1 }} />
        Oops, something went wrong. Please try again.
      </DataText>
    );
  }

  // If there is no data
  if ((showUnPaidDistributions && !unPaidDistributionsExist)
    || (!showUnPaidDistributions && !paidDistributionsExist)) {
    return (
      <DataText>
        There are no current distributions as of yet.
        Please come visit later when amounts have been distributed.
      </DataText>
    );
  }

  // If the results have been filtered to nothing
  if ((showUnPaidDistributions && !unPaidDistributions.length)
    || (!showUnPaidDistributions && !displayedData.length)) {
    return (
      <DataText>
        No results found
      </DataText>
    );
  }

  if (showUnPaidDistributions) {
    const tables = unPaidDistributions.map((fund) => (
      <TotalAmountTable
        distributionData={fund.distribution}
        showUnPaidDistributions
        distributionLabel={fund.fundName}
        fundCode={fund.fundFamily}
        key={`${fund.fundName}-${fund.fundFamily}`}
        fundTotalDistributions={fund.fundTotalDistributions}
      />
    ));

    return <>{tables}</>;
  }

  if (showOtherDistributions) {
    return (
      <TotalAmountTable
        distributionData={displayedData}
        showOtherDistributions
        distributionLabel="Other Distributions"
      />
    );
  }

  const tables = displayedData.map((yearlyDistribution) => (
    <TotalAmountTable
      distributionData={yearlyDistribution.distribution}
      showUnPaidDistributions={false}
      distributionLabel={`${yearlyDistribution.year} Distributions`}
      key={yearlyDistribution.year}
      fundTotalDistributions={yearlyDistribution.totalAnnualDistribution}
      year={yearlyDistribution.year}
    />
  ));

  return <>{tables}</>;
};

DistributionsDataDisplay.propTypes = {
  isError: PropTypes.bool.isRequired,
  showUnPaidDistributions: PropTypes.bool.isRequired,
  unPaidDistributionsExist: PropTypes.bool.isRequired,
  paidDistributionsExist: PropTypes.bool.isRequired,
  displayedData: PropTypes.arrayOf(PropTypes.object).isRequired,
  unPaidDistributions: PropTypes.arrayOf(PropTypes.object).isRequired,
  showOtherDistributions: PropTypes.bool,
};

DistributionsDataDisplay.defaultProps = {
  showOtherDistributions: false,
};

export default DistributionsDataDisplay;
